import React from 'react';

const ArrowDown = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.833008 14.9755H29.1173M14.9751 0.833329V29.1176" stroke="#1E3E43" strokeWidth="1.66667"
            strokeLinecap="round"/>
    </svg>


  );
};

export default ArrowDown;
